import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faX, faLock} from '@fortawesome/free-solid-svg-icons';
import { Grid } from '../../components/grid';
import Formulario from './formulario';
import { SpinnerPersonalizado } from "../../components/spinnerPersonalizado";
import FormularioContrasenha from './formularioContrasenha';
import { FormularioModal } from '../../components/ventanaModal';
import { AgregarUsuario, ActualizarUsuario, InactivarUsuario, ObtenerUsuarios, ObtenerUsuarioPorId, ActualizarContrasenhaTemporal } from '../../servicios/ServicioUsuarios'
import { AlertDismissible } from '../../components/alerts';
import { ConfirmModal } from '../../components/ConfirmModal';

const Usuarios = () => {
    const [proceso, setProceso] = useState(1);
    const [modal, setModal] = useState(false);
    const [modalTitulo, setModalTitulo] = useState("Registrar usuario");
    const [labelButton, setLabelButton] = useState("Registrar");
    const [mensajeFormulario, setMensajeFormulario] = useState("");
    const [mensajeRespuesta, setMensajeRespuesta] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const [listaDeUsuarios, setListaDeUsuarios] = useState([]);
    const [pendiente, setPendiente] = useState(false);
    const [filaSeleccionada, setFilaSeleccionada] = useState({});
    const [data, setData] = useState({});
    const [bloquearBoton, setBloquearBoton] = useState(true);
    const [textoBotonInactivar, setTextoBotonInactivar] = useState("Inactivar");
    const [textoBotonActualizar, setTextoBotonActualizar] = useState("Actualizar");

    const [modalContrasenha, setModalContrasenha] = useState(false);
    const [mensajeFormularioContrasenha, setMensajeFormularioContrasenha] = useState("");

    const [PermisoAgregar, setPermisoAgregar] = useState(false);
    const [PermisoActualizar, setPermisoActualizar] = useState(false);
    const [PermisoEliminar, setPermisoEliminar] = useState(false);

    const [IdUsuario, setIdUsuario] = useState(1);

    const [isLoading, setIsLoading] = useState(false);

    const encabezado = [
        { id: 'id', name: 'id', selector: row => row.id, head: "id", omit: true },
        { id: 'nombre', name: 'Nombre', selector: row => row.nombre, head: "Nombre", sortable: true },
        { id: 'apellido1', name: 'P. Apellido', selector: row => row.primerApellido, head: "P. Apellido", sortable: true },
        { id: 'apellido2', name: 'S. Apellido', selector: row => row.segundoApellido, head: "S. Apellido", sortable: true },
        { id: 'Rol', name: 'Rol', selector: row => row.descripcion, head: "Rol" },
        { id: 'nombreSucursal', name: 'Sucursal', selector: row => row.nombreSucursal, head: "Sucursal" , sortable: true },
        { id: 'Estado', name: 'Estado', selector: row => row.estado, head: "Estado"  }
    ]

    const filterColumns = ['nombre', 'primerApellido', 'segundoApellido', 'nombreSucursal','descripcion' ];

    useEffect(() => {
        ObtenerListadoDeUsuarios();
        ObtenerPermisosUsuario();
    }, []);

    const onClickNuevoUsuario = () => {
        setProceso(1);
        setModal(!modal);
        setLabelButton("Registrar");
        setModalTitulo("Registrar usuario");
    }

    const onClickActualizarUsuario = async () => {
        //setIsLoading(true);

        setData(await ObtenerUsuarioPorId(filaSeleccionada.idUsuario));
        setProceso(2);
        setModal(!modal);


        if (!PermisoActualizar) {
            setModalTitulo("Información usuario");
        }
        else {
            setModalTitulo("Actualizar usuario");

        }

        setLabelButton("Actualizar");


        //setIsLoading(false);
    }


    const onClickInactivarUsuario = async () => {
        setConfirmModalOpen(true);
    }
    const onConfirmCambioEstado = async () => {

        setIsLoading(true);
        const respuesta = await InactivarUsuario(filaSeleccionada.idUsuario)
        if (respuesta.indicador === 0)
            ObtenerListadoDeUsuarios();
        setMensajeRespuesta(respuesta);
        setTextoBotonInactivar(textoBotonInactivar === "Activar" ? "Inactivar" : "Activar");
        setConfirmModalOpen(false);
        setShowAlert(true);

        setIsLoading(false);
    }

    const ObtenerPermisosUsuario = () => {
        let usuario = JSON.parse(sessionStorage.getItem("data_usuario"));
        setPermisoAgregar(usuario.PermisoAgregar ?? false);
        setPermisoActualizar(usuario.PermisoActualizar ?? false);
        setPermisoEliminar(usuario.PermisoEliminar ?? false);


        //aprovecha el metodo para obtener el id del usuario logueado
        setIdUsuario(usuario.idUsuario);

        //aprovecha el metodo para asignar el texto del boton dependiendo del permiso
        if (usuario.PermisoActualizar) {
            setTextoBotonActualizar("Actualizar")
        }
        else {
            setTextoBotonActualizar("Ver Información")
        }

    }

    const ObtenerListadoDeUsuarios = async () => {
        setPendiente(true);
        setListaDeUsuarios(await ObtenerUsuarios());
        setPendiente(false);
    }

    const onClickProcesarUsuario = async (data) => {
        setIsLoading(true);

        data.usuarioCreacion = IdUsuario; 
        setMensajeFormulario("");
        let respuesta = {};
        if (proceso === 1)
            respuesta = await AgregarUsuario(data);
        else {
            data.idUsuario = filaSeleccionada.idUsuario;
            data.idPersona = filaSeleccionada.idPersona;
            respuesta = await ActualizarUsuario(data);
        }

        console.log(respuesta);

        if (respuesta.indicador === 0) {
            setModal(false);
            ObtenerListadoDeUsuarios();
            setMensajeRespuesta(respuesta);
        } else {
            setMensajeRespuesta(respuesta);
            setShowAlert(true);
        }
        setShowAlert(true);
        setIsLoading(false);
    }


    const onClickSeleccionarFila = (fila) => {
        const filaValida = ValidarSiFilaFueSeleccionada(fila);
        setBloquearBoton(!filaValida);
        setTextoBotonInactivar(!filaValida ? "Inactivar" : (fila.estado == "Activo" ? "Inactivar" : "Activar"));
        setFilaSeleccionada(fila);
    }

    const onClickCerrarModal = () => {
        setModal(false);
        setMensajeFormulario("");
    }

    const ValidarSiFilaFueSeleccionada = (fila) => Object.entries(fila).length === 0 ? false : true;

    const onClickActualizarContrasenha = async () => {
        setData(await ObtenerUsuarioPorId(filaSeleccionada.idUsuario));
        setModalContrasenha(true);
    }

    const onClickCerrarModalContrasenha = () => setModalContrasenha(false);

    const onClickProcesarContrasenha = async (data) => {
        data.idUsuario = filaSeleccionada.idUsuario;
        const respuesta = await ActualizarContrasenhaTemporal(data);
        if (respuesta.indicador == 0) {
            setModalContrasenha(false);       
            setMensajeRespuesta(respuesta);
            setShowAlert(true);
        } else {
            setMensajeFormularioContrasenha(respuesta.mensaje);
        }
    }

    return (
        <>

            <SpinnerPersonalizado show={isLoading} />


            <div className="container-fluid">
                <h1>Mantenimiento de usuarios</h1>
                <hr />
                {PermisoAgregar && (
                    <>
                        <Button
                            className="mr-1 mb-2 card-button"
                            variant="primary"
                            type="submit"
                            size="sm"
                            onClick={() => onClickNuevoUsuario()}>
                            <FontAwesomeIcon icon={faPlus} className="mr-2" />
                            Registrar
                        </Button>{' '}
                    </>
                )}
                    <Button
                        className="mr-1 mb-2 card-button"
                        variant="primary"
                        type="submit"
                        size="sm"
                        onClick={() => onClickActualizarUsuario()}
                        disabled={bloquearBoton}>
                        <FontAwesomeIcon icon={faPen} className="mr-2" />
                        {textoBotonActualizar}
                    </Button>{' '}
                {PermisoEliminar && (
                    <>
                        <Button
                            className="mr-1 mb-2 danger-button"
                            variant="danger"
                            type="submit"
                            size="sm"
                            onClick={() => onClickInactivarUsuario()}
                            disabled={bloquearBoton}>
                            <FontAwesomeIcon icon={faX} className="mr-2" />
                            {textoBotonInactivar}
                        </Button>
                    </>
                )}

                <br /><br />
                {showAlert && (
                    <AlertDismissible
                        indicador={mensajeRespuesta.indicador}
                        mensaje={mensajeRespuesta.mensaje}
                        setShow={setShowAlert}
                    />
                )} 
                <span>Listado de todas los usuarios registrados</span>
                <Grid gridHeading={encabezado} gridData={listaDeUsuarios} selectableRows={true} filterColumns={filterColumns} pending={pendiente}
                    setFilaSeleccionada={onClickSeleccionarFila} idBuscar="idUsuario" />
                <br /><br />
            </div>
            <FormularioModal show={modal} handleClose={onClickCerrarModal} titulo={modalTitulo} className='' tamano="lg">
                <Formulario labelButton={labelButton} data={data} proceso={proceso}
                    onClickProcesarUsuario={onClickProcesarUsuario} PermisoActualizar={PermisoActualizar} mensaje={mensajeFormulario}/>
            </FormularioModal>
            <FormularioModal show={modalContrasenha} handleClose={onClickCerrarModalContrasenha} titulo={"Actualizar Contraseña temporal"} className='' >
                <FormularioContrasenha data={data} onClickProcesarContrasenha={onClickProcesarContrasenha} mensaje={mensajeFormularioContrasenha} />
            </FormularioModal>
            {confirmModalOpen && (
                <ConfirmModal
                    isOpen={confirmModalOpen}
                    toggle={() => setConfirmModalOpen(!confirmModalOpen)}
                    message={`¿Desea cambiar el estado del usuario a ${textoBotonInactivar === "Activar" ? "activo" : "inactivo"
                        }?`}
                    onConfirm={onConfirmCambioEstado}
                />
            )}
        </>
    )
}

export default Usuarios;